.avatarWrapper {
  min-width: 56px;
  flex-shrink: 0;
}
.listPickerWrapper {
  padding-right: 48px;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  padding-left: 16px;
  padding-right: 16px;
  width: 100%;
  display: flex;
  position: relative;
  box-sizing: border-box;
  text-align: left;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 8px;
  justify-content: flex-start;
  text-decoration: none;
}
.listPickerTextWrapper {
  flex: 1 1 auto;
  min-width: 0;
  margin-top: 4px;
  margin-bottom: 4px;
  text-align: left;
}
.listPickerText {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}
.listPickerCheckbox {
  top: 50%;
  right: 16px;
  position: absolute;
  transform: translateY(-50%);
}
.listPickerContainer{
  position: relative;
  padding-right: 48px;
}
.listPickerId {
  color: #757575;
  font-size: 0.8rem;
}
